import _ from 'lodash';
import * as ActionTypes from '../../actions/types/website/PageActionTypes';

const initialState = {
  byId: {},
  typeToId: {},
  orderedIds: [],
  hideablePagesById: {},
  orderedHideablePageIds: [],
  activePage: {}
};

const pagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_PAGES: {
      return state;
    }
    case ActionTypes.RECEIVE_PAGES: {
      const byId = {};
      const typeToId = {};
      action.payload.pages.forEach(page => (byId[page.id] = page));
      action.payload.pages.forEach(page => (typeToId[page.type] = page.id));
      const orderedIds = action.payload.pages.map(page => page.id);
      return Object.assign({}, state, { byId, typeToId, orderedIds });
    }
    case ActionTypes.RECEIVE_PAGE: {
      const updatedPage = action.payload.page;
      const copy = Object.assign({}, state.byId);
      copy[action.payload.page.id] = updatedPage;
      return Object.assign({}, state, { byId: copy });
    }
    case ActionTypes.RECEIVE_HIDDEN_PAGE_SUGGESTIONS: {
      const { hiddenSuggestions } = action.payload;
      const orderedHideablePageIds = hiddenSuggestions.map(page => page.id);
      const hideablePagesById = _.keyBy(hiddenSuggestions, 'id');
      return Object.assign({}, state, { orderedHideablePageIds, hideablePagesById });
    }
    case ActionTypes.TOGGLE_PAGE: {
      const copy = Object.assign({}, state.byId);
      copy[action.payload.id] = Object.assign({}, state.byId[action.payload.id], { hidden: !copy[action.payload.id].hidden });
      return Object.assign({}, state, { byId: copy });
    }
    case ActionTypes.MOVE_PAGE: {
      const copy = Object.assign([], state.orderedIds);
      copy.splice(action.newIndex, 0, copy.splice(action.oldIndex, 1)[0]);
      return Object.assign({}, state, { orderedIds: copy });
    }
    case ActionTypes.ACTIVATE_PAGE: {
      const activePageId = state.typeToId[action.activePage];
      const activePageObject = state.byId[activePageId];
      const activePage = { type: action.activePage, id: activePageId, activePageObject };
      return Object.assign({}, state, { activePage });
    }
    default: return state;
  }
};

export default pagesReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/website/pages.js
 **/